const ACCOUNT_CLIENT_SESSION_ID_KEY = 'braileAccountClientSessionId'
const ACCOUNT_BROWSER_SESSION_ID_KEY = 'braileAccountBrowserSessionId'
const ACCOUNT_REQUEST_ID_KEY = 'braileAccountRequestId'

const createSessionId = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

const getAccountBrowserStorageKey = (accountId) => (
  `${ACCOUNT_BROWSER_SESSION_ID_KEY}:${accountId}`
)

const getAccountRequestStorageKey = (browserSessionId) => (
  `${ACCOUNT_REQUEST_ID_KEY}:${browserSessionId}`
)

export const getAccountClientSessionId = () => {
  let sessionId = window.sessionStorage.getItem(ACCOUNT_CLIENT_SESSION_ID_KEY)
  if (!sessionId) {
    sessionId = createSessionId()
    window.sessionStorage.setItem(ACCOUNT_CLIENT_SESSION_ID_KEY, sessionId)
  }
  return sessionId
}

export const getAccountBrowserSessionId = (accountId) => {
  const storageKey = getAccountBrowserStorageKey(accountId)
  let sessionId = window.localStorage.getItem(storageKey)
  if (!sessionId) {
    sessionId = createSessionId()
    window.localStorage.setItem(storageKey, sessionId)
  }
  return sessionId
}

export const getAccountRequestId = (browserSessionId) => {
  const storageKey = getAccountRequestStorageKey(browserSessionId)
  let requestId = window.localStorage.getItem(storageKey)
  if (!requestId) {
    requestId = window.sessionStorage.getItem(ACCOUNT_REQUEST_ID_KEY)
    if (requestId) window.localStorage.setItem(storageKey, requestId)
  }
  return requestId
}

export const setAccountRequestId = (requestId, browserSessionId) => {
  const storageKey = getAccountRequestStorageKey(browserSessionId)
  if (requestId) window.localStorage.setItem(storageKey, requestId)
  else window.localStorage.removeItem(storageKey)
  window.sessionStorage.removeItem(ACCOUNT_REQUEST_ID_KEY)
}

export const buildAccountSessionQuery = ({
  browserSessionId,
  clientSessionId,
  callId,
} = {}) => {
  const query = new URLSearchParams({ browserSessionId, clientSessionId })
  const requestId = getAccountRequestId(browserSessionId)
  if (requestId) query.set('requestId', requestId)
  if (callId) query.set('callId', callId)
  return query.toString()
}
